import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-521e8cb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-bold text-black" }
const _hoisted_2 = { class: "area-desc" }
const _hoisted_3 = { class: "area-desc" }

import { withDefaults } from 'vue';
import { ISeasonality } from '@/types';
  
  interface IProps {
        items?: ISeasonality[];
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'AtomTableModal',
  props: {
    items: {}
  },
  setup(__props: any) {

  const props = __props;

  const colorsBg = [
    '#FFF',
    '#FFF',
    '#FFF',
    '#F6F7F9',
    '#F6F7F9',
    '#F6F7F9',
    '#EAECF6',
    '#EAECF6',
    '#EAECF6',
    '#AAD3FF',
    '#AAD3FF',
    '#AAD3FF',
  ]

  const colorsBgQuarter = [
    '#FFF',
    '#F6F7F9',
    '#EAECF6',
    '#AAD3FF',
  ]
  
return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: "border-row border rounded-lg",
    style: {"flex-wrap":"nowrap"}
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, idx) => {
        return (_openBlock(), _createBlock(_component_v_col, {
          key: String(idx),
          class: _normalizeClass(`border-item`),
          style: _normalizeStyle(props.items[0].month == 'Q1'? {background: colorsBgQuarter[idx]} : {background: colorsBg[idx]})
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(item.month), 1),
            _createElementVNode("p", _hoisted_2, _toDisplayString(item.percentage), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(item.value), 1)
          ]),
          _: 2
        }, 1032, ["style"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})